import { Location } from '@eo-storefronts/eo-core'
import { createState } from '~/src/hooks/useEoState'

export const MARKETPLACE_SUGGESTED_LOCATIONS_STATE = createState<Location[]>({
  key: 'marketplaceSuggestedLocationsState',
  default: []
})
